import React, { HTMLAttributes, useEffect } from "react";
import { observer } from "mobx-react-lite";
import Layout from "components/Layout";
import cx from "classnames";
import Bgimg from "@/assets/images/academy/trading.png";

// import { Hooks } from "@xt/xtbase";
// const { useTranslation } = Hooks;
// import store from "store";

import styles from "./index.module.less";

interface Props extends HTMLAttributes<HTMLDivElement> {
  attr?: any;
}

const Main: React.FC<Props> = ({ className }) => {
  // const t = useTranslation();
  // const {isLogin} = store.user;
  useEffect(() => {
    const htmlEl = document.documentElement;
    htmlEl.style.fontSize = "39px";
  }, []);

  return (
    <Layout>
      <div className={cx(styles.trading, className)}>
        <img src={Bgimg} />
        <ul>
          <li>
            <div>
              <h2>Trading</h2>
              <h4>As you would with fiat currencies, trading is just as common in the crypto world.</h4>
              <h4>
                As you might have heard, blockchain and cryptocurrencies are already used in a lot of different areas. Undoubtedly, one of the biggest current
                use cases is speculation.
              </h4>
              <h4>
                Trading generally implies a shorter-term approach to generating profit. Traders may jump in and out of positions all the time. But how do they
                know when to get in and out?
              </h4>
              <h4>
                One of the most common ways to make sense of the cryptocurrency market is through an approach called technical analysis (TA). Technical analysts
                look at price history, charts, and other types of market data to find bets that have a good chance of returning a profit.
              </h4>
              <h4>
                You must be dying to get started right away. And technically, you could. It's that easy! But, like most things worth pursuing, trading is hard!
                It would take us a long time to talk about all that you need to keep in mind.
              </h4>
            </div>
          </li>
        </ul>
      </div>
    </Layout>
  );
};

export default observer(Main);
// export default Main;
